<template>
  <div class="top">
    <!-- 右边输入框和信息展示 -->
    <div class="infoList">   
      <div class="emptyImgContainer" v-if="isNone">
        <div v-if="showHelperPrompt" class="chatLeft1">
      <img src="../../src/assets/icon/备课助手.png" alt="助手头像" class="head_portrait" />
      <div class="ques1">
        <div class="text1">{{ helperPrompt }}</div>
      </div>
    </div>
      </div>      
      <!-- 信息 -->
      <div v-else class="infoTop" ref="scrollBox" id="box">
        <div
          class="chatInfoLeft"
          v-for="(item, index) in allInfoList"
          :key="index"
        >
          <div class="ques">
            <!-- 问题 -->
            <div class="chatRight">
              <div class="quesText" v-html="item.ques"></div>
            </div>
            <img
              src="../../src/assets/icon/用户头像.png"
              alt="用户头像"
              class="head_portrait1"
            />
            <!-- <img src="@/assets/users.png" alt="头像" class="head_portrait" /> -->
          </div>
          <div class="ans">
            <!-- 答案 -->
            <img
              src="../../src/assets/icon/备课助手.png"
              alt="助手头像"
              class="head_portrait"
            />
            <!-- <img src="@/assets/ans1.png" alt="头像" class="head_portrait" /> -->
            <div class="chatLeft">
              <div class="text" v-html="item.answer"></div>
            </div>
          </div>
        </div>
        <!-- 当没有allInfoList数据时候显示单独问题和答案 -->
        <div class="chatInfoLeft" v-if="textContent">
          <div class="ques">
            <!-- 问题 -->
            <div class="chatRight">
              <div class="quesText" v-html="textContent"></div>
            </div>
            <img
              src="../../src/assets/icon/用户头像.png"
              alt="用户头像"
              class="head_portrait1"
            />
            <!-- <img src="@/assets/users.png" alt="头像" class="head_portrait" /> -->
          </div>
          <div class="ans">
            <!-- 答案 -->
            <img
              src="../../src/assets/icon/备课助手.png"
              alt="助手头像"
              class="head_portrait"
            />
            <!-- <img src="@/assets/ans1.png" alt="头像" class="head_portrait" /> -->
            <div class="chatLeft">
              <!-- <div class="text" id="answer"></div> -->
              <p class="text">{{ answer }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="infoBottom">
        <!-- 只有 deepseek-v3 按钮 -->
        <button
           class="custom-button"
          :class="{ active: modelName === 'deepseek-v3' }"
          @click="toggleModel"
        >
        <span class="el-icon-cpu"></span>deepseek-v3
        </button>
        <!-- 输入框 -->
        <textarea
          type="textarea"
          placeholder="请输入问题"
          class="infoInput"
          v-model="textarea"
          @keydown.enter.exact="handlePushKeyword($event)"
          @keyup.ctrl.enter="lineFeed"
        ></textarea>
      </div>
    </div>
  </div>
</template>
<script>
import { getFormData } from "@/utils";
// import Recorder from "js-audio-recorder";
import axios from "axios";
// import KnowledgeChat from "@/components/KnowledgeChat.vue";
export default {
  name: "knowledgeChat",
  components: {
    // KnowledgeChat,
  },
  data() {
    return {
      showHelperPrompt: true, // 控制是否显示助手提示信息
      helperPrompt: '请问有什么可以帮到你的吗?', // 助手提示信息
 // 初始化自定义属性
      // 聊天记录
      chatRecord: [],
      // 聊天框
      chatInput: "",
      // 语音识别
      isRecognizing: false,
      // isRecommending:false,
      isRelevant: false,
      unicodeString: "\\u4f60\\u597d",
      decodedString: "",
      // chunkArray:[],
      answerSource: "",
      arr: [],
      microphoneAccessGranted: false,
      microphoneAccessDenied: false,
      errorMessage: "",
      devices: [],
      data1: [],
      data2: [],
      // 图谱展示
      getgraphDialogVisible: false,
      // 文档来源
      centerDialogVisible: false,
      chunksContent: [],
      getgraphDialogVisibleContent: "",
      // 问题和答案
      loading: true,
      loadingRE: true,
      // reply: [],
      audio: "",
      sourceDetail: false,
      // 开始录音的icon
      recording: false,
      // 录音
      // recorder: null,
      // recorder: new Recorder({
      //   sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
      //   sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
      //   numChannels: 1, // 声道，支持 1 或 2， 默认是1
      // }),

      // 选择来源
      value: [],
      options: [],
      drawer: false,
      // 其他相关问题的绑定
      othersQA: "",
      recommendQues: [],
      // 是否展示相关问题推荐
      isshowQA: false,
      // 没有一条提问时
      isNone: true,

      // 加号弹框
      dialogVisible: false,
      textContent: "",
      // 全部需要传的信息
      allInfoList: [
        // 1.
        /* {
          id: 1,
          // 问题
          ques: "在吗",
          // 答案
          answer: "在的",
          // 相关信息 recommendQues
          // 是否显示文件来源和相关推荐
          sourceDetail: false,
        }, */
      ],
      //滚动条距离顶部距离
      scrollTop: 0,
      //发送和输入显隐
      isshow: 0,
      // 重新加载
      timer: "",

      // 流式输出
      //输入框
      textarea: "",
      modelName: "gpt",
      // textContent: "",
      // 全部需要传的信息
      // allInfoList: [
      // 1.
      /* {
          id: 1,
          // 问题
          ques: "在吗",
          // 答案
          answer: "在的",
          // 相关信息 recommendQues
          // 是否显示文件来源和相关推荐
          sourceDetail: false,
        }, */
      // ],
      source: null,
      // reply: [],
      messages: "",
      answer: "",
      conversationId: "",
      // 语音输入
      // mediaRecorder: null,
      chunks: [],
      isRecording: false,
      audioUrl: "",
      // messages:'',
    };
  },
  mounted() {
    this.showHelperPrompt = true;
  },
  created() {
    // this.getRecommend(this.textContent, this.answer);
  },
  watch: {
  // 当 allInfoList 或 textContent 发生变化时，滚动到底部
  allInfoList() {
    this.scrollToBottom();
  },
  textContent() {
    this.scrollToBottom();
  },
},
  methods: {
    toggleRecording() {
      if (!this.isRecording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },
     // 自动滚动到底部的方法
  scrollToBottom() {
    this.$nextTick(() => {
      const scrollBox = this.$refs.scrollBox;
      if (scrollBox) {
        scrollBox.scrollTop = scrollBox.scrollHeight;
      }
    });
  },
    // startRecording() {
    //   // let knowledgeDB_name = sessionStorage.getItem("knowledgeDB_name");
    //   // if(!knowledgeDB_name){
    //   //   this.$message.error("请先选择知识库");
    //   //   return;
    //   // }
    //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //     navigator.mediaDevices.getUserMedia({ audio: true })
    //       .then(stream => {
    //         this.mediaRecorder = new MediaRecorder(stream);
    //         this.mediaRecorder.start();
    //         this.isRecording = true;
    //         this.mediaRecorder.ondataavailable = event => {
    //           this.$message.info("正在处理语音，请稍等");
    //           this.chunks.push(event.data);
    //           this.$message.success("处理完成");

    //         };
    //         this.mediaRecorder.onstop = () => {
    //           const blob = new Blob(this.chunks, { type: 'audio/webm' });
    //           this.convertToWavAndSend(blob);
    //           this.chunks = []; // 清空 chunks 以便下次录制
    //         };
    //       })
    //       .catch(error => {
    //         console.error('获取麦克风权限失败:', error);
    //       });
    //   } else {
    //     alert('您的浏览器不支持录音功能，请升级或更换浏览器。');
    //   }
    // },
    // stopRecording() {
    //   if (this.mediaRecorder) {
    //     this.mediaRecorder.stop();
    //     this.isRecording = false;
    //   }
    // },
    convertToWavAndSend(blob) {
      // 转换 WebM Blob 为 WAV Blob
      const reader = new FileReader();
      reader.onload = (event) => {
        const arrayBuffer = event.target.result;
        // 假设有一个函数 convertToWav 可以完成转换
        const wavBlob = this.convertToWav(arrayBuffer);
        this.sendAudioToServer(wavBlob);
      };
      reader.readAsArrayBuffer(blob);
    },
    convertToWav(arrayBuffer) {
      // 实际的转换逻辑
      // 这里只是一个占位符，实际转换需要更复杂的操作
      return new Blob([arrayBuffer], { type: "audio/wav" });
    },
    sendAudioToServer(wavBlob) {
      const formData = new FormData();
      formData.append("wav_file", wavBlob, "recording.wav");

      axios
        .post("/main/radio2Text", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log("Speech to Text Result:", response.data.data);
          this.messages = response.data.data;
          this.textarea = this.messages;

          // 处理后端返回的结果
        })
        .catch((error) => {
          console.error("Error sending audio to server:", error);
        });
    },
    getgraph() {
      this.getgraphDialogVisible = true;
      // 重新加载组件
      this.timer = new Date().getTime();
    },
    // 侧边栏数据接收
    /* getData() {
      let _this = this
      // 接收点击传过来的知识库
      this.eventBus.$on('knowledgeDB_name', (data) => {
        _this.knowledgeDB_name = data
      })
      // 点击当前选中的热点问题
      this.eventBus.$on('content', (data) => {
        _this.textarea = data
      })
    }, */

    // 知识图谱
    getknowledge() {
      const params = {
        conversation_id: this.conversationId,
      };
      axios
        .get(`/main/get_neo4j_data`, { params })
        .then((res) => {
          // 处理成功的响应
          console.log(res.data.data);
          this.data1 = res.data.data.node_info_list;
          this.data2 = res.data.data.relation_triplet_list;
        })
        .catch((error) => {
          // 处理错误
          console.log(error);
        });
    },
    getFile() {
      this.centerDialogVisible = true;
    },
    async getFileSource() {
      console.log(this.conversationId, "conversationId");
      const params = {
        conversation_id: this.conversationId,
      };
      // 获取相关文件
      const { data: res } = await axios.get(`/main/get_chunk`, { params });
      console.log(res.data, "sssssss");
      this.chunksContent = res.data;
    },
    // 回到指定顶部的相关信息位置
    toTop() {
      this.$refs.scrollBox.scrollTop = 0;
    },

    // 选项来源改变对应切换相关内容
    handleSelect(value) {
      // 将抽屉从上面打开展示信息
      console.log(value, "value");
      this.drawer = true;
    },

    // 点击选中的相关推荐问题
    recommendQuesClick(data) {
      // 点击选中的问题推荐，绑定到对话框
      this.textarea = data;
    },

    //————————上传wav录音数据——————————
    async uploadWAVData(wav_file) {
      const formData = getFormData({
        wav_file,
      });
      const { data: res } = await this.axios.post("/main/radio2Text", formData);
      this.textarea = res.data;
      // 语音转文字成功提示
      this.$message({
        message: "语音输入成功，请查看进行提问",
        type: "success",
      });
    },
    // handleStart() {
    //   this.requestMicrophoneAccess();
    //   if ((this.recording = !this.recording)) {
    //     if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    //       this.$message({
    //         message: "请先允许该网页使用麦克风",
    //         type: "info",
    //       });
    //       return;
    //     }

    //     navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
    //       this.recorder = new Recorder();
    //       this.recorder.start(); // 开始录音
    //     });
    //   } else {
    //     this.handleStop();
    //     this.formData = new FormData();
    //     this.uploadWAVData(this.recorder.getWAVBlob());
    //   }
    // },
    // handleStop() {
    //   this.recorder.stop();
    // },
    // ————————————————————————————
    // 保存问题
    // async saveQuestion(text) {
    //   const { data: res } = await this.axios.get(
    //     `/api2/question/save?text=${text}&?projectId=${sessionStorage.getItem("knowledgeDB_id")}`
    //   );
    // },
    async saveQuestion() {
      console.log(this.textContent, 'sessionStorage.getItem("knowledgeDB_id")');
      const { data: res } = await this.axios.get(`/api2/question/save?`, {
        params: {
          text: this.textContent,
          projectId: sessionStorage.getItem("knowledgeDB_id"),
        },
      });
      console.log(res, "res");
    },
    // 切换 deepseek-v3
    toggleModel() {
      this.modelName = this.modelName === "deepseek-v3" ? "gpt" : "deepseek-v3";
      // this.$message.success(`模型已切换为 ${this.modelName}`);
    },
    async setUp() {
      // 判断 textarea 是否为空
      if (this.textarea === "") {
        this.$message.error("请先输入问题");
        return;
      } else {
        this.textContent = this.textarea;
        this.getgraphDialogVisibleContent = this.textContent;
        let _this = this;
        _this.textContent = _this.textarea;
        let score = Number(0.75);
        let top_k = Number(3);
        // let modelName = String("gpt2");
        sessionStorage.setItem("textarea", this.textarea);

        // 打印发送的 id，查看 textarea 和 knowledgeDB_id
        console.log(
          this.textContent,
          sessionStorage.getItem("knowledgeDB_id"),
          "发送的id"
        );

        // 进行提问时显示提示
        this.isNone = false;
        this.$message.info("正在进行提问，请稍等");

        if (_this.textarea == "") {
          _this.$message.error("请先输入问题");
          return;
        }

        // 清空 textarea
        _this.textarea = "";
        console.log(`当前选中的模型: ${this.modelName}`);

        // 构建请求的 URL，检查 modelName 参数是否传递
        const url = `/main/stream_chat?projectId=${sessionStorage.getItem(
          "needId"
        )}&query=${encodeURIComponent(
          this.textContent
        )}&top_k=${top_k}&score=${score}&modelName=${encodeURIComponent(
          this.modelName
        )}`;

        // 打印 URL 来确认所有参数传递正确
        console.log("请求的URL：", url);

        // 使用 EventSource 进行流式请求
        _this.source = new EventSource(url);

        // 监听消息事件
        _this.source.addEventListener(
          "message",
          (e) => {
            console.log(e.data, "e.data");
            let a = JSON.parse(e.data);
            console.log(a.text, "a.text");
            _this.messages += a.text;
            _this.answer += a.text.replace(/\\n/g, "\n"); // 替换换行符
            console.log(_this.answer, "this.answer");
            _this.conversationId = a.conversation_id;
            console.log(a.conversation_id, "this.conversationId");
          },
          false
        );

        // 初始化 answer
        _this.answer = "";

        // 监听错误事件
        _this.source.addEventListener(
          "error",
          (e) => {
            if (e.target.readyState === EventSource.CLOSED) {
              console.log("Disconnected");
            } else if (e.target.readyState === EventSource.CONNECTING) {
              _this.source.close();
              // 错误时调用相关方法
              _this.isRelevant = true;
              // 全部流式输出之后，放到整个数组中 qaPairs
              _this.allInfoList.push({
                ques: _this.textContent,
                answer: _this.answer,
              });

              // 用于文本到语音转换
              _this.audioTest = "";
              _this.allInfoList.forEach((item) => {
                _this.audioTest = item.answer;
              });
              _this.getAudio();

              // 清理并更新 UI
              _this.messages = _this.messages.replace(/\\n/g, "\n");
              _this.answer = "";
              _this.textarea = "";
              _this.textContent = "";
              _this.conversationId = "";
            }
          },
          false
        );

        // 打开连接时的回调
        _this.source.onopen = function () {
          console.log("EventSource connection opened");
        };

        // 页面滚动到底部
        _this.$nextTick(() => {
          _this.setPageScrollTo();
          _this.$refs.scrollBox.scrollTop =
            _this.$refs.scrollBox.scrollHeight - 30;
        });
      }
    },

    handleIncomingData(data) {
      this.conversationId = data.conversation_id;
      this.text = data.text;
      this.status = data.status;
    },
    // 文字转语音
    getAudio() {
      axios
        .post("/main/text2Radio", null, {
          params: {
            text: this.audioTest,
          },
        })
        .then((response) => {
          const responseData = response.data.data.base64;
          this.audio = `data:audio/wav;base64,${responseData}`;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getRecommend(response, query) {
      console.log(this.conversationId, "this.conversationId");
      this.recommendQues = [];
      let _this = this;
      console.log(typeof query, typeof response), "打印数据类型";
      this.axios({
        method: "post",
        url: "/main/questionRecommend",
        params: {
          conversation_id: this.conversationId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        const lengthArray = res.data.data.length;
        const arrayData = res.data.data;
        console.log(arrayData, "arrayData");
        if (lengthArray != 0) {
          _this.isshowQA = true;
          _this.recommendQues = arrayData;
          this.loading = false; // 更新加载状态
          // _this.isRecommending=false
          // 给出消息提示
          this.$message({
            message: "推荐成功",
            type: "success",
          });
        } else {
          // _this.$message({
          //   message: "暂无推荐",
          //   type: "warning",
          // });
          // _this.isshowQA = false;
        }
        // _this.recommendQues = res.data.data;
        // console.log(res.data.data,'res.data.data')
        // res.data.data.forEach(item=>{
        //  this.chunkArray.push(item.page_content)
        // })
        // if (res.data.data.length != 0) {
        //   // 给出消息提示
        //   _this.$message({
        //     message: "推荐成功",
        //     type: "success",
        //   });
        //   _this.isshowQA = true;
        // } else {
        //   _this.isshowQA = false;
        //   _this.$message({
        //     message: "暂无推荐",
        //     type: "warning",
        //   });
        //   _this.loadingRE = false;
        // }
      });
    },
    // 监听键盘回车阻止换行并发送
    handlePushKeyword(event) {
      if (event.keyCode === 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        this.setUp(); //发送文本
        return false;
      }
      this.showHelperPrompt = false; // 输入问题后隐藏提示信息
    },
    // 监听按的是ctrl + 回车，就换行
    lineFeed() {
      this.textarea = this.textarea + "\n";
    },

    //点击icon
    extend(val) {
      alert("你点击了：" + val);
    },
    //滚动条默认滚动到最底部
    setPageScrollTo(s, c) {
      console.log(s, c, "s,c");
      //获取中间内容盒子的可见区域高度
      this.scrollTop = document.querySelector("#box").offsetHeight;
      setTimeout(() => {
        //加个定时器，防止上面高度没获取到，再获取一遍。
        if (this.scrollTop != this.$refs.scrollBox.offsetHeight) {
          this.scrollTop = document.querySelector("#box").offsetHeight;
        }
      }, 100);
      //scrollTop：滚动条距离顶部的距离。
      //把上面获取到的高度座位距离，把滚动条顶到最底部
      this.$refs.scrollBox.scrollTop = this.scrollTop;
      //判断是否有滚动条,有滚动条就创建一个监听滚动事件，滚动到顶部触发srTop方法
      if (this.$refs.scrollBox.scrollTop > 0) {
        this.$refs.scrollBox.addEventListener("scroll", this.srTop);
      }
    },
    //滚动条到达顶部
    srTop() {
      //判断：当滚动条距离顶部为0时代表滚动到顶部了
      if (this.$refs.scrollBox.scrollTop == 0) {
        //逻辑简介：
        //到顶部后请求后端的方法，获取第二页的聊天记录，然后插入到现在的聊天数据前面。
        //如何插入前面：可以先把获取的数据保存在 A 变量内，然后 this.userInfoList=A.concat(this.userInfoList)把数组合并进来就可以了
        //拿聊天记录逻辑:
        //第一次调用一个请求拉历史聊天记录，发请求时参数带上页数 1 传过去，拿到的就是第一页的聊天记录，比如一次拿20条。你显示出来
        //然后向上滚动到顶部时，触发新的请求，在请求中把分页数先 +1 然后再请求，这就拿到了第二页数据，然后通过concat合并数组插入进前面，依次类推，功能完成！
        //   alert("已经到顶部了");
      }
    },
  },
};
</script>

<style lang="less" scoped>
br {
  display: block;
  margin: 0;
  padding: 0;
}
.top {
  height: 100%;
  width: 100%;
  // background: linear-gradient(135deg, #ebf5fd, #f6fafe);
  background-color: rgba(8, 52, 107, 0.747);
  // border-radius: 0 12px 12px 0;
  // border-radius: 12px;
}

.source_file {
  margin-left: 6px;
}

/deep/ .el-drawer {
  height: 50% !important;
  border-radius: 0 0px 10px 10px;
  background: #f5f5f6;

  .el-drawer__header {
    padding: 0;
    margin: 0;
    margin-top: 5px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }

  .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }

  .el-drawer__body {
    padding: 10px;
  }
}

/deep/ .chatInfoLeft {
  /deep/ .el-cascader .el-input .el-input__inner {
    border: none;
  }
}

.wrap {
  height: 80%;
  width: 55%;
  background-color: #f2f2f2;
  margin: auto;
  transform: translateY(10%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
}

.titleBox {
  height: 10%;
  width: 100%;
  background-image: linear-gradient(to right, #1e76bc, #69a3d5);
  display: flex;
  align-items: center;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.infoBtn2 {
  // margin-top: 12px;
  display: flex;
  height: 30%;
  // height: 58%;
  align-items: center;
  justify-content: flex-end;
}

/* 头像 */
.head_portrait {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.head_portrait1 {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

/* 信息外层盒子 */
.infoList {
  height: 100%;
  width: 92%;
  margin: 0 auto;
  display: flex; /* 使用flex布局 */
  flex-direction: column; /* 子元素垂直排列 */
  align-items: flex-start; /* 左对齐 */
  // background-color: rgb(132, 179, 172);
}
.infoBottom {
  position: relative; /* 让子元素绝对定位相对于此 */
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}

/* 按钮样式 */
.custom-button {
  position: absolute;
  top:90%; /* 放在文本框的上方 */
  left: 0; /* 靠左对齐 */
  background-color: #bbc4cf;
  color: black;
  border: none;
  padding: 1px 6px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
}

.custom-button:hover {
  background-color: #7d858f;
}
.custom-button.active {
  background-color: #67b1de; /* 选中状态：亮橙色 */
  color: blue;
  transform: scale(1.05); /* 选中状态放大一点 */
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2); /* 增加阴影 */
}

/* 输入框样式 */
.infoInput {
  opacity: 0.7;
  padding: 10px;
  margin: 10px 0;
  width: 100%;
  height: 40px;
  resize: none;
  box-sizing: border-box;
  background: #f5f5f6;
  border-radius: 12px;
  color: #000000;
  outline-color: rgba(83, 160, 231, 0.61);
  font-size: 16px;
}

.emptyImgContainer {
  height: 88%;
  width: 98%;
  display: flex;
}
.chatLeft1 {
  display: flex; /* 使用 Flexbox 布局 */
  text-align: justify;
  min-width: 85%;
  margin-left: 15px;
  flex: 1;
  }
  .head_portrait1 {
    // width: 50px; /* 根据需要调整头像大小 */
    // height: 50px; /* 根据需要调整头像大小 */
    margin-right: 10px; /* 头像和文本之间的间距 */
    border-radius: 50%; /* 圆形头像 */
  }
  .ques1 {
    margin-top: 10px;
    height:20px ;
    padding: 10px; /* 对话框内边距 */
    border-radius: 7px; /* 对话框圆角 */
    color: white;
    background-color: #283968;
    max-width: 70%; /* 对话框最大宽度，根据需要调整 */
  }
  .text1 {
    white-space: pre-wrap; /* 保持文本格式 */
  }
/* 信息列表 */
.infoTop {
  height: 88%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto; /* 隐藏滚动条 */
  position: relative; /* 确保容器可滚动 */
}

/* 完全隐藏滚动条 */
.infoTop::-webkit-scrollbar {
  display: none;
}

/* 保留滚动功能，可以使用 JavaScript 或其他方法滚动 */


/* 对方发的信息样式 */
.chatInfoLeft {
  min-height: 70px;
  margin-left: -10px;
  margin-top: 10px;

  .ques {
    display: flex;
    margin-bottom: 10px;
  }

  .ans {
    display: flex;
  }

  .el-button {
    margin: 5px 0 5px 5px;
  }
}

  .chatLeft {
  text-align: justify;
  min-width: 85%;
  margin-left: 15px;
  flex: 1;
}

.chatInfo {
  text-align: justify;
  margin-left: 10px;
  flex: 1;
  min-width: 91%;
  color: white;
  background-color: #283968;
  margin-top: 8px;
  display: inline-block;
  padding: 6px 3px;
  border-radius: 10px;
  max-width: 75%;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  white-space: pre-wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.recommendbutton {
  white-space: normal;
  word-wrap: break-word;
  margin: 5px;
  /* 设置宽度，以便按钮内的文字能换行 */
  // max-width: 500px;
}

.ans > .chatLeft > .text {
  text-align: justify;
  color: white;
  background-color: #283968;
  margin-left: -6px;
  margin-top: 8px;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 10px;
  max-width: 95%;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  white-space: pre-wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.quesText {
  text-align: justify;
  color: #434343;
  background-color: #a8e1e9;
  margin-top: 8px;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 10px;
  max-width: 95%;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  white-space: pre-wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

/* 自己发的信息样式 */
.chatInfoRight {
  height: 70px;
  margin-left: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: row-reverse;
}

.chatRight {
  margin-right: 15px;
  flex: 1;
  /* 用align-items把元素靠右对齐 */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.chatRight .text {
  color: white;
  margin-top: 8px;
  background-color: #95ec69;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 10px;
  max-width: 95%;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  white-space: pre-wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.searchBox {
  padding: 4px 2px;
  border-bottom: 1px solid #ededed;
}

.input-with-select {
  width: 80%;
  margin-right: 2%;
}

/* 点击用户变色 */
.userFlexAct {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  background-color: #e8e8e8;
}

/* 用户默认颜色 */
.userFlex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
}

/* 用户名 */
.userName {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 简略信息 */
.userInfo {
  width: 100px;
  font-size: 14px;
  color: #ccc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 3px;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #dbd9d9;
  border-radius: 3px;
}

.alone-info {
  display: flex;
  margin-left: 6%;

  .info-sourse {
    display: flex;
    align-items: center;

    .el-cascader {
      margin-left: 6%;
    }
  }

  .audio {
    display: flex;
    justify-content: flex-start;
    margin-top: 5px;
  }

  .recommend {
    min-height: 30px;
    background-color: none;
    display: inline-block;
    padding: 6px 10px;
    border-radius: 10px;
    min-width: 80%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    white-space: normal;

    p,
    .el-button {
      margin: 5px 10px 0px 0px !important;
    }
  }

  audio {
    width: 150px;
    margin: 5px 20px 5px 0;
  }

  audio::-webkit-media-controls-timeline-container,
  audio::-webkit-media-controls-current-time-display,
  audio::-webkit-media-controls-time-remaining-display,
  audio::-webkit-media-controls-timeline,
  audio::-webkit-media-controls-seek-back-button,
  audio::-webkit-media-controls-seek-forward-button,
  audio::-webkit-media-controls-fullscreen-button,
  audio::-webkit-media-controls-rewind-button,
  audio::-webkit-media-controls-return-to-realtime-button,
  audio::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
  }
}
.el-icon-microphone {
  color: white;
}
.el-icon-microphone:hover {
  color: rgb(19, 67, 211);
}
.alone-info audio {
  margin-top: 10px;
}
</style>
